import SectionBreadcrumbs from './SectionBreadcrumbs';

export default SectionBreadcrumbs;
